export default __webpack_public_path__ + "static/media/TVSapacheFamilia.ac7ba0f9.webp";